import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { CrudService } from "src/app/services/crud.service";
import { ResponseAPI, UserType } from "src/models/user.model";
import { LoadingController, ModalController, Platform } from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { AuthService } from "src/app/services/auth.service";
import { UtilService } from "../../services/util.service";
import { SaldoVendedorService } from "src/app/services/saldo-vendedor.service";
import { SaldoMotoristaService } from "src/app/services/saldo-motorista.service";
import { WithdrawalModalComponent } from "src/app/components/withdrawal-modal/withdrawal-modal.component";
import { register } from "swiper/element/bundle";

import { IonicSlides } from "@ionic/angular";
import { PaymentService } from "src/app/services/payment.service";

register();

export interface Balance {
  saldoTotal: number;
  saldoEmAberto: number;
  saldoRecebido: number;
  saldoDiario: number;
  saldoSemanal: number;
  saldoBonus: number;
  saldoBonusDia: number;
  saldoBonusSemanal: number;
  saldoBonusAnual: number;
  saldoGanhoDiarioMotorista: number;
  saldoGanhoSemanalMotorista: number;
  saldoGanhoAnualMotorista: number;
  terminoData: Date;
}

@Component({
    selector: "app-balance-driver",
    templateUrl: "./balance-driver.page.html",
    styleUrls: ["./balance-driver.page.scss"],
    standalone: false
})
export class BalanceDriverPage implements OnInit, OnDestroy {
  sub: Subscription;
  periodos = [];
  year = new Date().getFullYear();
  claim: UserType;
  userType = UserType;

  public swiperModules = [IonicSlides];

  earningsCorridas = this.buildEarningsCorridas();
  earningsTotais = this.buildEarningsTotais();

  availableBalance: number = 0;

  constructor(
    private crud: CrudService,
    private loadCtrl: LoadingController,
    private auth: AuthService,
    private util: UtilService,
    private platform: Platform,
    private paymentService: PaymentService,
    private modalCtrl: ModalController,
    private saldoVendedor: SaldoVendedorService,
    private saldoMotorista: SaldoMotoristaService,
  ) {}

  async ngOnInit() {
    this.claim = await this.auth.getClaim();
    await this.loadData();
    await this.loadAvailableBalance();
  }

  async loadAvailableBalance() {
    if (this.claim === this.userType.Caller) {
      this.saldoVendedor.getMyBalance().subscribe({
        next: (res: any) => { this.availableBalance = res?.saldoDisponivelParaSaque ?? 0; },
        error: () => { /* ignore — balance may not exist yet */ },
      });
    } else if (this.claim === this.userType.Driver) {
      this.saldoMotorista.getMyBalance().subscribe({
        next: (res: any) => { this.availableBalance = res?.saldoDisponivelParaSaque ?? 0; },
        error: () => {},
      });
    }
  }

  async openWithdrawalModal() {
    if (this.claim !== this.userType.Caller && this.claim !== this.userType.Driver) return;
    const modal = await this.modalCtrl.create({
      component: WithdrawalModalComponent,
      componentProps: {
        availableBalance: this.availableBalance,
        claim: this.claim === this.userType.Caller ? 'Caller' : 'Driver',
      },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data?.submitted) {
      await this.loadAvailableBalance();
    }
  }

  getPageTitleByClaim() {
    if (this.claim === this.userType.Caller) {
      return "Earnings";
    }
    return "Records";
  }

  getUrlByClaim() {
    switch (this.claim) {
      case this.userType.Caller:
        return "earnings/caller";
      case this.userType.Restaurant:
        return "restaurante/earnings";
      case this.userType.Driver:
        return "restaurante/earnings/driver";
      default:
        throw new Error("Invalid claim: " + this.claim);
    }
  }

  async loadData(event?: any) {
    await this.showLoading();

    this.sub = this.crud.getData(this.getUrlByClaim()).subscribe(
      async (response: any) => {
        await this.loadCtrl.dismiss();
        this.earningsTotais = response;
      },
      async (error) => {
        await this.loadCtrl.dismiss();
        if (event) {
          setTimeout(() => {
            event.target.complete();
          }, 2000);
        }
      }
    );
  }

  async payPlatform() {
    await this.showLoading();
    this.crud.getData("motorista/realizar-pagamento-plataforma").subscribe(
      async (response: any) => {
        // BaseController wraps in { success: true, data: ... } now
        const ok = response === "Ok"
          || response?.success === true
          || response?.data?.ok === true
          || response?.data === "Ok";
        if (ok) {
          this.loadData();
          await this.util.openCashApp();
        }
        await this.loadCtrl.dismiss();
      },
      async (error) => {
        await this.loadCtrl.dismiss();
        await this.util.showToast(
          "Error retrieving data. Please check your internet connection"
        );
      }
    );
  }

  async payRaces() {
    if (this.earningsTotais.semanaAtualCorrida.saldoEmAberto > 0) {
      await this.paymentService.openPaymentModal();
    } else {
      await this.util.showToast("No outstanding balance");
    }
    // await this.paymentService.openPaymentModal();
  }

  async payServices() {
    if (this.earningsTotais.semanaAtualRestaurante.valorTransferir > 0) {
      await this.paymentService.openPaymentModal();
    } else {
      await this.util.showToast("No outstanding balance");
    }
    // await this.paymentService.openPaymentModal();
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadCtrl.create(loadingProps);
    return await loading.present();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  buildEarningsCorridas() {
    return {
      saldoTotal: 0,
      saldoEmAberto: 0,
      saldoRecebido: 0,
      saldoDiario: 0,
      saldoSemanal: 0,
      saldoBonus: 0,
      saldoBonusDia: 0,
      saldoBonusSemanal: 0,
      saldoBonusAnual: 0,
      saldoGanhoDiarioMotorista: 0,
      saldoGanhoSemanalMotorista: 0,
      saldoGanhoAnualMotorista: 0,
      terminoData: new Date(),
      label: "",
      corridasSemana: 0,
      corridasFinalizadasSemana: 0,
      corridasCanceladasSemana: 0,
      periodos: [
        {
          labelMes: "October",
          data: [
            {
              id: "",
              label: "Oct 2 - Oct 8",
              valor: 0,
            },
            {
              id: "",
              label: "Oct 4 - Oct 3",
              valor: 0,
            },
          ],
        },
        {
          labelMes: "September",
          data: [
            {
              id: "",
              label: "Set 2 - Set 8",
              valor: 0,
            },
            {
              id: "",
              label: "Set 4 - Set 3",
              valor: 0,
            },
          ],
        },
      ],
    };
  }
  buildEarningsTotais() {
    return {
      semanaAtualCorrida: {
        saldoTotal: 0,
        saldoEmAberto: 0,
        saldoRecebido: 0,
        saldoDiario: 0,
        saldoSemanal: 0,
        saldoBonus: 0,
        saldoBonusDia: 0,
        saldoBonusSemanal: 0,
        saldoBonusAnual: 0,
        saldoGanhoDiarioMotorista: 0,
        saldoGanhoSemanalMotorista: 0,
        saldoGanhoAnualMotorista: 0,
        terminoData: new Date(),
        label: "",
        corridasSemana: 0,
        corridasFinalizadasSemana: 0,
        corridasCanceladasSemana: 0,
        periodos: [
          {
            labelMes: "October",
            data: [
              {
                id: "",
                label: "Oct 2 - Oct 8",
                valor: 0,
              },
              {
                id: "",
                label: "Oct 4 - Oct 3",
                valor: 0,
              },
            ],
          },
          {
            labelMes: "September",
            data: [
              {
                id: "",
                label: "Set 2 - Set 8",
                valor: 0,
              },
              {
                id: "",
                label: "Set 4 - Set 3",
                valor: 0,
              },
            ],
          },
        ],
      },
      semanaAtualRestaurante: {
        id: "",
        label: "Nov 2 - Nov 8",
        totalRecebido: 0,
        reservas: 0,
        numeroPessoas: 0,
        finalizados: 0,
        cancelados: 0,
        recusados: 0,
        valorTransferir: 0,
      },
      periodos: [
        {
          labelMes: "October",
          data: [
            {
              id: "",
              label: "Oct 2 - Oct 8",
              valor: 0,
            },
            {
              id: "",
              label: "Oct 4 - Oct 3",
              valor: 0,
            },
          ],
        },
        {
          labelMes: "September",
          data: [
            {
              id: "",
              label: "Set 2 - Set 8",
              valor: 0,
            },
            {
              id: "",
              label: "Set 4 - Set 3",
              valor: 0,
            },
          ],
        },
      ],
    };
  }
}
